import React, {} from "react" ;

import ScrollRails from "../../Common/Body/ScrollRails";
import ChildAppBodyHeader from "./ChildAppBodyHeader";

import {Route, Switch} from "react-router-dom";
import {getChildRouterPath, PATH_CHILD_ROOT} from "root/Wieldy/routePaths";
import ConnectionsTab from "root/Wieldy/ApplicationModules/Child/Body/ChildConnections/ConnectionsTab";
import FamiliesTab from "root/Wieldy/ApplicationModules/Child/Body/Families/FamiliesTab";
import PostsTab from "root/Wieldy/ApplicationModules/Posts/Body/PostsTab";
import AgreementsPageBody from "root/Wieldy/ApplicationModules/Child/Body/Agreements/AgreementsPageBody";
import ChildInfoForm from "root/Wieldy/ApplicationModules/Child/Body/ChildDetails/ChildInfoForm";
import FamilyMembersTab from "root/Wieldy/ApplicationModules/Child/Body/Families/FamilyMembersTab";
import ChildDashboardTab from "root/Wieldy/ApplicationModules/Child/Body/ChildDashboards/ChildDashboardTab";
import LetterboxTab from "root/Wieldy/ApplicationModules/Letterbox/Body/LetterboxTab";
import ChildResourcesTab from "root/Wieldy/ApplicationModules/Child/Body/ChildResources/ChildResourcesTab";
import MyCalendar from "root/Calendar/Calendar";
import MessagingTab from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingTab";
import {useRecoilValue} from "recoil";
import AgreementPageBody from "root/Wieldy/ApplicationModules/Child/Body/Agreements/AgreementPageBody";
import {currentChildAtom} from "root/recoil/childId";

const ChildAppBody= (props) =>
{
    const current_child = useRecoilValue(currentChildAtom);

    return (
    <div className="dt-module__container">

        <ChildAppBodyHeader child_uid={props.child_uid} child_name = {current_child.known_as}/>

        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={getChildRouterPath('details')} render={(thisprops) => <ChildInfoForm child_uid={props.child_uid } {...thisprops}/>}/>
                        <Route path={getChildRouterPath('posts')} render={(thisprops) => <PostsTab child_uid={props.child_uid} is_editor = {current_child.is_editor} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('letterbox')} render={(thisprops) => <LetterboxTab child_uid={props.child_uid} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('calendar')} render={(thisprops) => <MyCalendar child_uid={props.child_uid} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('messaging')} render={(thisprops) => <MessagingTab child_uid={props.child_uid} unenc_child_uid = {current_child.idusers} is_editor = {current_child.is_editor}{...thisprops}/>}/>
                        <Route path={getChildRouterPath('connections')} render={(thisprops) => <ConnectionsTab {...thisprops}/>}/>
                        <Route exact path={getChildRouterPath('families')} render={(thisprops) => <FamiliesTab child_id={props.child_uid } {...thisprops}/>}/>
                        <Route exact path={getChildRouterPath('families/adoptee/:family_id')} render={(thisprops) => <FamilyMembersTab child_id={props.child_uid } {...thisprops}/>}/>
                        <Route path={getChildRouterPath('commsplans/:communications_plan_id')} render={(thisprops) => <AgreementPageBody child_uid={props.child_uid } {...thisprops}/>}/>
                        <Route path={getChildRouterPath('commsplans')} render={(thisprops) => <AgreementsPageBody child_uid={props.child_uid } {...thisprops}/>}/>
                        <Route path={getChildRouterPath('resources')} render={(thisprops) => <ChildResourcesTab child_uid={props.child_uid } {...thisprops}/>}/>
                        <Route path={getChildRouterPath('stats')} render={(thisprops) => <ChildDashboardTab child_uid={props.child_uid } {...thisprops}/>}/>
                        { ( current_child.is_manager || current_child.is_editor) &&<Route path={PATH_CHILD_ROOT} render={(thisprops) => <ChildInfoForm child_uid={props.child_uid } {...thisprops}/>}/>}
                        { ( current_child.is_messager) &&<Route path={PATH_CHILD_ROOT} render={(thisprops) => <MessagingTab child_uid={current_child.child_uid} unenc_child_uid = {current_child.idusers} is_editor = {current_child.is_editor}{...thisprops}/>}/>}
                        { ( current_child.is_contributor) &&<Route path={PATH_CHILD_ROOT} render={(thisprops) => <PostsTab child_uid={current_child.child_uid} is_editor = {current_child.is_editor} {...thisprops}/>}/>}
                    </Switch>
                </div>
            </div>

            <ScrollRails />

        </div>
    </div>
    ) ;
}

export default ChildAppBody;
